import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ShareButton from '../ShareButton';
import FeedbackButtons from '../FeedbackButtons';
import BookmarkButton from '../BookmarkButton';
import BaseContext from '../../containers/BasePage/BaseContext';
import { CookieStateContext } from '../../containers/BasePage/state';

import styles from './ShareFeedbackSegment.module.scss';

const ShareFeedbackSegment = ({
    showShare = true,
    showBookmark = true,
    showFeedback = true,
    id = 0,
    url = '',
    modifier = '',
}) => {
    const { isStorybook } = useContext(BaseContext);

    const { state } = useContext(CookieStateContext) || {};
    const cookieConsent = state?.categories?.includes('functionality');

    const classes = classNames(styles['ShareFeedbackSegment'], {
        [styles[`ShareFeedbackSegment--${modifier}`]]: modifier,
    });

    return (
        <div className={classes}>
            <div className={styles['ShareFeedbackSegment__Container']}>
                {(cookieConsent || isStorybook) && showBookmark && (
                    <div className={styles['ShareFeedbackSegment__Bookmark']}>
                        <BookmarkButton
                            url={url}
                            id={id}
                            untranslatedModifiers={['BookmarkButton--InsideShareFeedbackSegment']}
                            untranslatedButtonModifiers={['Button--InsideShareFeedbackSegment']}
                            isNextToShare={true}
                        />
                    </div>
                )}
                {showShare && (
                    <div className={styles['ShareFeedbackSegment__Share']}>
                        <ShareButton untranslatedButtonModifiers={['Button--InsideShareFeedbackSegment']} />
                    </div>
                )}
            </div>
            {showFeedback && (
                <div className={styles['ShareFeedbackSegment__Feedback']}>
                    <FeedbackButtons articleId={id} />
                </div>
            )}
        </div>
    );
};

ShareFeedbackSegment.propTypes = {
    showShare: PropTypes.bool,
    showBookmark: PropTypes.bool,
    showFeedback: PropTypes.bool,
    id: PropTypes.number,
    url: PropTypes.string,
    modifier: PropTypes.string,
};

export default ShareFeedbackSegment;
